import React from 'react'
import PropTypes from 'prop-types'

import { Accordion } from 'semantic-ui-react'

import GroupPermission from '../GroupPermission'
import GroupPermissionHeaderTitle from '../GroupPermissionHeaderTitle'

import { permissionKeys } from 'Global/permissionKeys'

const GroupPermissionsAccordion = ({ counts, handleSelection, selectedPermissions }) => {
  const general = Object.values(permissionKeys.general).map(permission => (
    <GroupPermission
      checked={selectedPermissions.includes(permission.key)}
      handleSelection={handleSelection}
      key={permission.key}
      permission={permission}
    />
  ))

  const modules = Object.values(permissionKeys.modules).map(permission => (
    <GroupPermission
      checked={selectedPermissions.includes(permission.key)}
      handleSelection={handleSelection}
      key={permission.key}
      permission={permission}
    />
  ))

  const pictureActions = Object.values(permissionKeys.picture.action).map(permission => (
    <GroupPermission
      checked={selectedPermissions.includes(permission.key)}
      handleSelection={handleSelection}
      key={permission.key}
      permission={permission}
    />
  ))

  const pictureFields = Object.values(permissionKeys.picture.field).map(permission => (
    <GroupPermission
      checked={selectedPermissions.includes(permission.key)}
      handleSelection={handleSelection}
      key={permission.key}
      permission={permission}
    />
  ))

  const picturePictures = Object.values(permissionKeys.picture.picture).map(permission => (
    <GroupPermission
      checked={selectedPermissions.includes(permission.key)}
      handleSelection={handleSelection}
      key={permission.key}
      permission={permission}
    />
  ))

  const rugActions = Object.values(permissionKeys.rug.action).map(permission => (
    <GroupPermission
      checked={selectedPermissions.includes(permission.key)}
      handleSelection={handleSelection}
      key={permission.key}
      permission={permission}
    />
  ))

  const rugFields = Object.values(permissionKeys.rug.field).map(permission => (
    <GroupPermission
      checked={selectedPermissions.includes(permission.key)}
      handleSelection={handleSelection}
      key={permission.key}
      permission={permission}
    />
  ))

  const rugStatus = Object.values(permissionKeys.rug.status).map(permission => (
    <GroupPermission
      checked={selectedPermissions.includes(permission.key)}
      handleSelection={handleSelection}
      key={permission.key}
      permission={permission}
    />
  ))

  const settings = Object.values(permissionKeys.settings).map(permission => (
    <GroupPermission
      checked={selectedPermissions.includes(permission.key)}
      handleSelection={handleSelection}
      key={permission.key}
      permission={permission}
    />
  ))

  const familyAlbum = Object.values(permissionKeys.familyAlbum).map(permission => (
    <GroupPermission
      checked={selectedPermissions.includes(permission.key)}
      handleSelection={handleSelection}
      key={permission.key}
      permission={permission}
    />
  ))

  const users = Object.values(permissionKeys.users).map(permission => (
    <GroupPermission
      checked={selectedPermissions.includes(permission.key)}
      handleSelection={handleSelection}
      key={permission.key}
      permission={permission}
    />
  ))

  const picturesPanel = [
    {
      key: 'pictureActions',
      title: {
        content: (
          <GroupPermissionHeaderTitle selected={counts.pictureActions.selected} settings={counts.pictureActions.total} title="Actions" />
        ),
        key: 'pictureActionsTitle',
      },
      content: { content: pictureActions, key: 'pictureActionsContent' },
    },
    {
      key: 'pictureFields',
      title: {
        content: (
          <GroupPermissionHeaderTitle selected={counts.pictureFields.selected} settings={counts.pictureFields.total} title="Fields" />
        ),
        key: 'pictureFieldsTitle',
      },
      content: { content: pictureFields, key: 'pictureFieldsContent' },
    },
    {
      key: 'picturePictures',
      title: {
        content: (
          <GroupPermissionHeaderTitle selected={counts.picturePictures.selected} settings={counts.picturePictures.total} title="Pictures" />
        ),
        key: 'picturePicturesTitle',
      },
      content: { content: picturePictures, key: 'picturePicturesContent' },
    },
  ]

  const rugsPanel = [
    {
      key: 'rugActions',
      title: {
        content: <GroupPermissionHeaderTitle selected={counts.rugActions.selected} settings={counts.rugActions.total} title="Actions" />,
        key: 'rugActionsTitle',
      },
      content: { content: rugActions, key: 'rugActionsContent' },
    },
    {
      key: 'rugFields',
      title: {
        content: <GroupPermissionHeaderTitle selected={counts.rugFields.selected} settings={counts.rugFields.total} title="Fields" />,
        key: 'rugFieldsTitle',
      },
      content: { content: rugFields, key: 'rugFieldsContent' },
    },
    {
      key: 'rugStatus',
      title: {
        content: <GroupPermissionHeaderTitle selected={counts.rugStatus.selected} settings={counts.rugStatus.total} title="Status" />,
        key: 'rugStatusTitle',
      },
      content: { content: rugStatus, key: 'rugStatusContent' },
    },
  ]

  const picturesContent = <Accordion.Accordion panels={picturesPanel} />
  const rugsContent = <Accordion.Accordion panels={rugsPanel} />

  const rootPanels = [
    {
      key: 'general',
      title: {
        content: <GroupPermissionHeaderTitle selected={counts.general.selected} settings={counts.general.total} title="General" />,
        key: 'generalTitle',
      },
      content: { content: general, key: 'generalContent' },
    },
    {
      key: 'modules',
      title: {
        content: <GroupPermissionHeaderTitle selected={counts.modules.selected} settings={counts.modules.total} title="Modules" />,
        key: 'modulesTitle',
      },
      content: { content: modules, key: 'modulesContent' },
    },
    {
      key: 'pictures',
      title: {
        content: <GroupPermissionHeaderTitle selected={counts.picture.selected} settings={counts.picture.total} title="Pictures" />,
        key: 'picturesTitle',
      },
      content: { content: picturesContent, key: 'picturesContent' },
    },
    {
      key: 'rugs',
      title: {
        content: <GroupPermissionHeaderTitle selected={counts.rug.selected} settings={counts.rug.total} title="Rugs" />,
        key: 'rugsTitle',
      },
      content: { content: rugsContent, key: 'rugsContent' },
    },
    {
      key: 'settings',
      title: {
        content: <GroupPermissionHeaderTitle selected={counts.settings.selected} settings={counts.settings.total} title="Settings" />,
        key: 'settingsTitle',
      },
      content: { content: settings, key: 'settingsContent' },
    },
    {
      key: 'familyAlbum',
      title: {
        content: (
          <GroupPermissionHeaderTitle selected={counts.familyAlbum.selected} settings={counts.familyAlbum.total} title="Family Album" />
        ),
        key: 'familyAlbumTitle',
      },
      content: { content: familyAlbum, key: 'familyAlbumContent' },
    },
    {
      key: 'users',
      title: {
        content: <GroupPermissionHeaderTitle selected={counts.users.selected} settings={counts.users.total} title="Users" />,
        key: 'usersTitle',
      },
      content: { content: users, key: 'usersContent' },
    },
  ]

  return <Accordion defaultActiveIndex={0} panels={rootPanels} fluid styled />
}

GroupPermissionsAccordion.propTypes = {
  counts: PropTypes.object.isRequired,
  handleSelection: PropTypes.func.isRequired,
  selectedPermissions: PropTypes.array.isRequired,
}

export default GroupPermissionsAccordion
